import styled from '@emotion/styled';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { Answer } from 'src/modules/assessments/components/Answer';
import { Grid } from 'src/shared/components/Grid';

import { remarks } from '../utils/feedbackRemarks';

import { UnorderedList } from './UnorderedList';

const MultiSelectAnswer = styled(Answer)(() => ({
    width: 240,
}));

interface FormProps {
    onChange: (value: string[]) => void;
    labels: string[];
}
export const CirclesOnDemandFeedbackMultiSelect: React.FC<FormProps> = ({ onChange, labels }) => {
    const { t } = useTranslation('circles');

    return (
        <>
            <Grid
                as={UnorderedList}
                expand={false}
                minItemWidth={240}
                rowGap={0}
                maxColumns={2}
                columnGap={10}
            >
                {remarks.map((remark, i) => (
                    <MultiSelectAnswer
                        key={`${remark.key}-${i}`}
                        isHighlighted={labels?.includes(remark.key)}
                        onClick={() => {
                            if (labels?.includes(remark.key)) {
                                const filtered = labels.filter(word => word !== remark.key);
                                onChange(filtered);
                            } else {
                                onChange([...labels, remark.key]);
                            }
                        }}
                    >
                        {t(remark.translation)}
                    </MultiSelectAnswer>
                ))}
            </Grid>
        </>
    );
};
